module.exports = __webpack_public_path__ + "static/kobe-1-88de8c59cc3f1f0496a91999882b886f.jpg";